import React from 'react';
import { JourneyOrder, Leg, LegStatus, NodeType } from './fetchJourneyOrder';
import { Step, StepLabel, Stepper } from '@material-ui/core';
import { Region } from '../../../types/orderTypes';

import './Journey.scss';
import { DeviationGroups } from './deviations/fetchDeviations';
import DeviationList from './deviations/DeviationList';
import DeviationForm from './deviations/DeviationForm';

interface Node {
  nodeType: NodeType;
  region: Region;
  departureDate?: string;
  arrivalDate?: string;
  arrivalStatus?: LegStatus;
  departureStatus?: LegStatus;
  legId: number;
}

function toNodes(journey: Leg[]): Node[] {
  const nodes: Node[] = [];
  [...journey]
    .sort((a, b) => a.legIndex - b.legIndex)
    .forEach(leg => {
      if (nodes.length === 0) {
        nodes.push({
          nodeType: leg.originNodeType,
          region: leg.originRegion,
          departureDate: leg.departureDate,
          departureStatus: leg.status,
          legId: leg.id,
        });
      } else {
        const lastNode = nodes[nodes.length - 1];
        nodes[nodes.length - 1] = {
          ...lastNode,
          nodeType: leg.originNodeType,
          region: leg.originRegion,
          departureDate: leg.departureDate,
          departureStatus: leg.status,
          legId: leg.id,
        };
      }
      nodes.push({
        nodeType: leg.destinationNodeType,
        region: leg.destinationRegion,
        arrivalDate: leg.arrivalDate,
        arrivalStatus: leg.status,
        legId: leg.id,
      });
    });
  return nodes;
}

interface Props {
  journeyOrder: JourneyOrder;
  deviations: DeviationGroups;
}

export default function Journey({
  journeyOrder,
  deviations,
}: Props): JSX.Element {
  const { order, journey } = journeyOrder;
  const nodes = toNodes(journey);
  return (
    <div className="journey">
      <div className="journey-order-info">
        <h4 className="order-id">Order id: {order.id}</h4>
        <h4 className="order-id">Order status: {order.status}</h4>
      </div>
      <Stepper
        activeStep={findLastIndexOr0(
          nodes,
          node => node.arrivalStatus === 'COMPLETED'
        )}
        alternativeLabel
      >
        {nodes.map((node, index) => {
          return (
            <Step key={index}>
              <StepLabel>
                <div>
                  <h5>{`${node.region} ${node.nodeType}`}</h5>
                  <p>
                    {(node.arrivalDate ? `${node.arrivalDate}` : '') +
                      (node.arrivalDate && node.departureDate ? ' - ' : '') +
                      (node.departureDate ? `${node.departureDate}` : '')}
                  </p>
                  <p>
                    {(node.arrivalStatus ? `${node.arrivalStatus}` : '') +
                      (node.arrivalStatus && node.departureStatus
                        ? ' - '
                        : '') +
                      (node.departureStatus ? `${node.departureStatus}` : '')}
                  </p>
                  {index % 2 === 0 && (
                    <DeviationList
                      orderId={journeyOrder.order.id}
                      legId={node.legId}
                      deviationGroups={deviations}
                    />
                  )}
                </div>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <DeviationForm
        orderId={journeyOrder.order.id}
        onSuccess={() => undefined}
      />
    </div>
  );
}

function findLastIndexOr0<T>(
  array: Array<T>,
  predicate: (value: T, index: number, obj: T[]) => boolean
): number {
  let l = array.length;
  while (l--) {
    if (predicate(array[l], l, array)) return l;
  }
  return 0;
}
